var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-cell-task-quick-view",on:{"click":_vm.openQuickView}},[_c('a',{attrs:{"href":_vm.taskUrl}},[_c('span',[_vm._v(_vm._s(_vm.$t('Details')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }